import {
	URL_HOME,
	URL_EQUIPE,
	URL_CONTACT,
	URL_DEVELOPPEMENT,
	URL_TIRAGE,
	URL_ACTUALITES,
	URL_WORKSHOPS,
	URL_RESULTATS,
	URL_TARIFS,
	URL_TARIFSDEV,
	URL_TARIFSNUM,
	URL_TARIFSTIRAGE,
	URL_TARIFSPF,
	URL_CORRESPONDANCE,
	URL_MENTIONS_LEGALES,
	URL_CGV,
	URL_PRODUITS,
	URL_TIRAGES,
	URL_TIRAGES_FORM,
} from '../constants';

export class PageWorker {
	static async getChildByHash(url) {
		let mainChildParams;

		const contentGetter = {
			[URL_HOME]: async () => {
				import('stylesheets/homepage.scss');
				const { homeContent } = await import('../content/mains/home');
				return [homeContent, 'HomePage'];
			},
			[URL_TIRAGE]: async () => {
				import('stylesheets/tirage.scss');
				const { tirageContent } = await import('../content/mains/tirage');
				return [tirageContent, 'TiragePage'];
			},
			[URL_DEVELOPPEMENT]: async () => {
				import('stylesheets/developpement.scss');
				const { devContent } = await import('../content/mains/developpement');
				return [devContent, 'DevPage'];
			},
			[URL_WORKSHOPS]: async () => {
				import('stylesheets/workshops.scss');
				const { workshopsContent } = await import(
					'../content/mains/workshops/workshops'
				);
				return [workshopsContent, 'WorkshopsPage'];
			},
			[URL_TARIFS]: async () => {
				import('stylesheets/tarifs.scss');
				const { tarifsSection } = await import(
					'../content/mains/tarifs/tarifs'
				);
				return [tarifsSection, 'Tarifs'];
			},
			[URL_TARIFSDEV]: async () => {
				import('stylesheets/tarifs.scss');
				const { tarifsSection } = await import(
					'../content/mains/tarifs/tarifs-dev'
				);
				return [tarifsSection, 'TarifsPage'];
			},
			[URL_TARIFSNUM]: async () => {
				import('stylesheets/tarifs.scss');
				const { tarifsSection } = await import(
					'../content/mains/tarifs/tarifs-num'
				);
				return [tarifsSection, 'TarifsPage'];
			},
			[URL_TARIFSTIRAGE]: async () => {
				import('stylesheets/tarifs.scss');
				const { tarifsSection } = await import(
					'../content/mains/tarifs/tarifs-tirage'
				);
				return [tarifsSection, 'TarifsPage'];
			},
			[URL_TARIFSPF]: async () => {
				import('stylesheets/tarifs.scss');
				const { tarifsSection } = await import(
					'../content/mains/tarifs/tarifs-planfilm'
				);
				return [tarifsSection, 'TarifsPage'];
			},
			[URL_ACTUALITES]: async () => {
				import('stylesheets/actualites.scss');
				const { actualitesContent } = await import(
					'../content/mains/actualites'
				);
				return [actualitesContent, 'ActusPage'];
			},
			[URL_RESULTATS]: async () => {
				import('stylesheets/resultats.scss');
				const { resultatsContent } = await import('../content/mains/resultats');
				return [resultatsContent, 'ResultatsPage'];
			},
			[URL_PRODUITS]: async () => {
				import('stylesheets/products.scss');
				const { productsContent } = await import(
					'../content/mains/products/products'
				);
				console.log({ productsContent });
				return [productsContent, 'ProduitsPage'];
			},
			[URL_EQUIPE]: async () => {
				import('stylesheets/equipe.scss');
				const { equipeContent } = await import('../content/mains/equipe');
				return [equipeContent, 'TeamPage'];
			},
			[URL_CONTACT]: async () => {
				import('stylesheets/contact.scss');
				const { contactContent } = await import('../content/mains/contact');
				return [contactContent, 'ContactPage'];
			},
			[URL_MENTIONS_LEGALES]: async () => {
				import('stylesheets/mentions-legales.scss');
				const { mentionsLegales } = await import(
					'../content/mains/mentions-legales'
				);
				return [mentionsLegales, 'MentionsLegalesPage'];
			},
			[URL_CGV]: async () => {
				import('stylesheets/cgv.scss');
				const { cgv } = await import('../content/mains/cgv');
				return [cgv, 'CgvPage'];
			},
			[URL_CORRESPONDANCE]: async () => {
				import('stylesheets/correspondance.scss');
				const { correspondanceContent } = await import(
					'../content/mains/correspondance'
				);
				return [correspondanceContent, 'CorrespondancePage'];
			},
			[URL_TIRAGES]: async () => {
				import('stylesheets/tirages-minilab.scss');
				const { tiragesContent } = await import(
					'../content/mains/minilab/tirages-minilab'
				);
				return [tiragesContent, 'TiragesPage'];
			},
			[URL_TIRAGES_FORM]: async () => {
				import('stylesheets/tirages-minilab.scss');
				const { tiragesFormContent } = await import(
					'../content/mains/minilab/tirages-minilab-form'
				);
				return [tiragesFormContent, 'TiragesForm'];
			},
		};

		if (url in contentGetter) {
			mainChildParams = await contentGetter[url]();
		} else {
			const { listLinkExpos } = await import('../content/mains/liste-expos');
			const URL_EXPO = listLinkExpos.find(
				(urlExpo) => urlExpo !== URL_RESULTATS && urlExpo === url
			);

			if (URL_EXPO) {
				import('stylesheets/expo.scss');
				const { getExpoContent } = await import('../content/mains/expo');
				const expoContent = await getExpoContent(url);
				mainChildParams = [expoContent, 'ExpoPage'];
			} else {
				const { listLinksWorkshops } = await import(
					'../content/mains/workshops/liste-workshops'
				);
				const URL_WORKSHOP = listLinksWorkshops.find(
					(urlWorkshop) => urlWorkshop === url
				);

				if (URL_WORKSHOP) {
					import('stylesheets/workshop.scss');
					const { getWorkshopContent } = await import(
						'../content/mains/workshops/workshop'
					);
					const workshopContent = await getWorkshopContent(url);
					mainChildParams = [workshopContent, 'WorkshopPage'];
				} else {
					const { listLinkProducts } = await import(
						'../content/mains/products/list-products'
					);
					const URL_PRODUCT = listLinkProducts.find(
						(urlProduct) => urlProduct === url
					);

					if (URL_PRODUCT) {
						import('stylesheets/product.scss');
						const { getProductContent } = await import(
							'../content/mains/products/product'
						);
						const productContent = await getProductContent(url);
						mainChildParams = [productContent, 'ProductPage'];
					} else {
						const { CatCentCat } = await import('./mains/CatCentCat');
						const { catCentCatContent } = await import(
							'../content/catCentCatContent'
						);
						return new CatCentCat(catCentCatContent, '_404_');
					}
				}
			}
		}

		const { MainChildren } = await import('./MainChildren');
		return new MainChildren(...mainChildParams);
	}
}
